import { useId } from "react";

/** Ticket mark: a rounded card with two centred tear notches and a perforation. */
export function Logo({ size = 24, mark = false, className = "" }: { size?: number; mark?: boolean; className?: string }) {
  const id = useId().replace(/:/g, "");
  const glyph = (
    <svg viewBox="0 0 64 64" width={size} height={size} aria-hidden="true" className="block shrink-0">
      <defs>
        <linearGradient id={`g${id}`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#a78bfa" />
          <stop offset="1" stopColor="#7c4ff0" />
        </linearGradient>
        <mask id={`m${id}`}>
          <rect width="64" height="64" fill="#fff" />
          <circle cx="32" cy="12" r="6" fill="#000" />
          <circle cx="32" cy="52" r="6" fill="#000" />
        </mask>
      </defs>
      <rect x="6" y="12" width="52" height="40" rx="9" fill={`url(#g${id})`} mask={`url(#m${id})`} />
      <line x1="32" y1="22" x2="32" y2="42" stroke="rgba(0,0,0,0.35)" strokeWidth="2" strokeDasharray="3 3" strokeLinecap="round" />
    </svg>
  );
  if (mark) return <span className={`inline-flex ${className}`}>{glyph}</span>;
  return (
    <span className={`inline-flex items-center ${className}`} style={{ gap: size * 0.4 }}>
      {glyph}
      <span className="font-bold leading-none tracking-[-0.03em] text-ink" style={{ fontSize: size * 0.78 }}>
        RewardPass
      </span>
    </span>
  );
}
